import queryString from 'qs';

const getHostCalendarScheduleRequest = (queryParams) => {
  const queries = {};

  if (queryParams?.startDate) queries['startedAt'] = `gte.${queryParams.startDate}`;
  if (queryParams?.endDate) queries['endedAt'] = `lte.${queryParams.endDate}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getHostCalendarScheduleRequest;
